import Collage from './Collage';
import {connect} from 'react-redux';

const mapStateToProps = (state) => {
    return {isLoggedIn:(state.auth.me && state.auth.me.profile) ? true : false};
};

export default connect(mapStateToProps,null)(Collage);
